import { render, staticRenderFns } from "./PsCardFooter.vue?vue&type=template&id=3759fe12&scoped=true&"
import script from "./PsCardFooter.vue?vue&type=script&lang=js&"
export * from "./PsCardFooter.vue?vue&type=script&lang=js&"
import style0 from "./PsCardFooter.vue?vue&type=style&index=0&id=3759fe12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3759fe12",
  null
  
)

component.options.__file = "PsCardFooter.vue"
export default component.exports